var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var SvgCareNeedsWhite = function SvgCareNeedsWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    xmlSpace: "preserve",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality"
    },
    viewBox: "0 0 10.8128 17.628",
    x: "0px",
    y: "0px",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M3.33697 12.3757c-1.05189,2.72157 -1.57559,4.22556 -1.57559,4.51206 1.19669,0.122699 0.821192,0.707193 0.631094,0.707193l-1.74568 0c-0.102899,0 -0.156699,-0.0536995 -0.156699,-0.156699 0,-0.576495 1.06649,-6.77194 1.27779,-6.64314 0.447396,0.272597 1.23649,1.05089 1.56909,1.58059z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M5.28025 4.73656c1.23099,1.39659 2.25598,2.24258 3.07957,2.52908 0.237298,0 0.501395,0.922091 0.801293,2.76627 0.0491995,0.0984991 0.604294,2.60068 1.65168,7.51553l-0.474496 0.0805993c-0.0707993,-0.162198 -2.10438,-8.68192 -2.37238,-9.57461 -2.56468,-0.836092 -2.42148,-1.01179 -2.76627,-3.31687l0.0805993 0z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    d: "M4.88075 5.87555c0.254098,2.24708 0.587095,3.98826 0.998791,5.22375 0.696494,1.09939 0.784293,4.20676 0.784293,5.68925 1.43169,0.0625994 0.879792,0.707193 0.771093,0.707193l-1.78748 0c-0.144599,0 -0.398696,-1.18619 -0.766693,-3.55407 -0.438196,-1.29369 -1.10849,-2.35008 -2.01538,-3.17367 -0.617794,-0.402796 -0.924491,-0.792293 -0.924491,-1.17719 0.201598,-1.58459 0.306697,-2.66338 0.306697,-3.24077 -0.512595,0.375997 -0.928791,1.40099 -1.24419,3.07957 0,1.06489 -0.978291,0.429696 -1.00339,0.317797 0.315497,-3.33027 1.27059,-5.33555 2.86537,-6.00704 1.56689,0 2.01538,0.234298 2.01538,2.13518z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "fil1",
    cx: 3.37987,
    cy: 1.71978,
    r: 1.71978
  }))));
};

export default __webpack_public_path__ + "static/media/care-needs-white.b2ac916b.svg";
export { SvgCareNeedsWhite as ReactComponent };